// File: src/components/pages/Bookings.jsx
// ServiceUser (Student) page - Book Slots and My Bookings tabs

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import BookYourSlots from './BookYourSlots';
import MyBookings from './MyBookings';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import '../../styles/unified.css';

export default function Bookings() {
  const { user } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  
  const isServiceUser = userRoles.includes('ServiceUser');

  const [activeTab, setActiveTab] = useState('book-slots');

  // Access control - only ServiceUser can access this page
  if (!isServiceUser) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>This page is only accessible to students.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    );
  }

  return (
    <div className="bookings-page">
      {/* Tab Navigation */}
      <div className="tabs-container">
        <button
          className={`tab ${activeTab === 'book-slots' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('book-slots')}
        >
          Book Slots
        </button>
        <button
          className={`tab ${activeTab === 'my-bookings' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('my-bookings')}
        >
          My Bookings
        </button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'book-slots' && <BookYourSlots />}
        {activeTab === 'my-bookings' && <MyBookings />}
      </div>
    </div>
  );
}